import { useCallback } from "react";
import _ from "lodash";
import useVademecum from "./hooks/useVademecum";
import useVademecumStrategy from "./hooks/useStrategy";


const PresentationPicker = ({
  form: { setValue, clearErrors },
  name,
  medicineIndex,
  setMedicineIndex
}) => {
  const vademecum = useVademecum();
  const medicine = vademecum[medicineIndex] || {};
  const { PresentationSelection: { WizardComponent, genericOnlyDefault } } = useVademecumStrategy();

  const handleComplete = useCallback((quantity, presentation) => {
    const { principioActivo, requiereDuplicado, marcaComercial } = _.find(vademecum, medicine => _.some(medicine.presentaciones, { regNo: presentation.regNo }));
    const { name: presentationName, regNo } = presentation;
    const medicineWithPresentation = `${principioActivo} ${presentationName} (${marcaComercial})`;
    setValue(`${name}.text`, medicineWithPresentation);
    setValue(`${name}.externalId`, regNo);
    setValue(`${name}.requiresDuplicate`, requiereDuplicado);
    setValue(`${name}.quantity`, quantity);
    if (genericOnlyDefault) setValue(`${name}.genericOnly`, genericOnlyDefault);
    setMedicineIndex(null);
    clearErrors(name);
  }, [medicine, name, setValue, setMedicineIndex, clearErrors]);

  if (!medicine?.principioActivo) return null;

  return (
    <WizardComponent 
      medicine={medicine}
      onComplete={handleComplete}
      onClose={() => setMedicineIndex(null)}
    />
  );
};

const VademecumInput = (props) => {
  const { name, setMedicineIndex, medicineIndex } = props;

  return (
    <>
      <PresentationPicker
        {...props}
        medicineIndex={medicineIndex}
        setMedicineIndex={setMedicineIndex}
      />

      <input type="hidden" name={`${name}`.quantity} />
      <input type="hidden" name={`${name}`.externalId} />
      <input type="hidden" name={`${name}`.requiresDuplicate} />
    </>
  );
};

export default VademecumInput;
